"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = exports.ApiErrorMessages = void 0;
const apisauce_1 = require("apisauce");
const DeviceRegistration_1 = __importDefault(require("../device/DeviceRegistration"));
exports.ApiErrorMessages = {
    not_setup: 'Api not setup, call API.setup(config);'
};
class ApiError extends Error {
    constructor(type) {
        super(exports.ApiErrorMessages[type]);
    }
}
exports.ApiError = ApiError;
class BaseAPI {
    static getInstance(config, options) {
        const apiInstance = (0, apisauce_1.create)(config);
        const { requestTransFormation, responseInterceptor } = options;
        apiInstance.addRequestTransform(request => {
            const device = DeviceRegistration_1.default.device;
            if (!device) {
                return;
            }
            if (device.deviceKey) {
                request.headers['X-DEVICE-KEY'] = device.deviceKey;
            }
        });
        if (requestTransFormation && !!requestTransFormation.addRequestTransform) {
            apiInstance.addRequestTransform(requestTransFormation.addRequestTransform);
        }
        if (requestTransFormation && !!requestTransFormation.addResponseTransform) {
            apiInstance.addResponseTransform(requestTransFormation.addResponseTransform);
        }
        if (requestTransFormation && !!requestTransFormation.asyncRequestTransform) {
            apiInstance.addAsyncRequestTransform(requestTransFormation.asyncRequestTransform);
        }
        if (requestTransFormation && !!requestTransFormation.monitor) {
            apiInstance.addMonitor(requestTransFormation.monitor);
        }
        if (responseInterceptor) {
            const { onFulfilled, onRejected } = responseInterceptor;
            apiInstance.axiosInstance.interceptors.response.use(onFulfilled, onRejected);
        }
        return apiInstance;
    }
    static async get(apiInstance, args) {
        if (!apiInstance) {
            throw new ApiError('not_setup');
        }
        const { url, query, headers, withCredentials } = args;
        BaseAPI.setHeaders(apiInstance, headers);
        const response = await apiInstance.get(url, query, {
            responseType: args.responseType,
            withCredentials
        });
        return BaseAPI.returnResponse(response);
    }
    static async post(apiInstance, args) {
        if (!apiInstance) {
            throw new ApiError('not_setup');
        }
        const { url, body, headers, onUploadProgress, cancelToken, withCredentials } = args;
        BaseAPI.setHeaders(apiInstance, headers);
        const response = await apiInstance.post(url, body, {
            onUploadProgress,
            cancelToken,
            withCredentials
        });
        return BaseAPI.returnResponse(response);
    }
    static async delete(apiInstance, args) {
        if (!apiInstance) {
            throw new ApiError('not_setup');
        }
        const { url, query, headers, withCredentials } = args;
        BaseAPI.setHeaders(apiInstance, headers);
        const response = await apiInstance.delete(url, query, {
            responseType: args.responseType,
            withCredentials
        });
        return BaseAPI.returnResponse(response);
    }
    static async put(apiInstance, args) {
        if (!apiInstance) {
            throw new ApiError('not_setup');
        }
        const { url, body, headers, withCredentials } = args;
        BaseAPI.setHeaders(apiInstance, headers);
        const response = await apiInstance.put(url, body, { withCredentials });
        return BaseAPI.returnResponse(response);
    }
    static reset(apiInstance) {
        return BaseAPI.setHeaders(apiInstance, {});
    }
    static setHeaders(apiInstance, headers) {
        if (!apiInstance) {
            throw new ApiError('not_setup');
        }
        if (headers) {
            if (!headers['Content-Type']) {
                headers['Content-Type'] = 'application/json';
            }
        }
        else {
            headers = {
                'Content-Type': 'application/json'
            };
        }
        return apiInstance.setHeaders(headers);
    }
    static returnResponse(response) {
        if (!response.ok && response.problem) {
            const data = response.data;
            const error = response && data && (data.title || data.message)
                ? data.title || data.message
                : response && response.originalError && response.originalError.message;
            return Promise.reject({
                message: error,
                payload: response.data
            });
        }
        return response.data;
    }
}
exports.default = BaseAPI;
//# sourceMappingURL=BaseAPI.js.map